import { apiService } from "api/apiService";
import type {
  ClassroomGroupMeetingResource,
  LessonClassOpenGroupMeetingResource,
} from "api/generated";
import { lessonClassOpenGroupMeetingFromDto } from "classroom/mappers";
import type { ClassroomLessonClassOpenGroupMeeting } from "classroom/types";
import { groupMeetingFromDto } from "meetings/group-meeting/api/mappers";
import type {
  GroupMeeting,
  GroupMeetingDto,
} from "meetings/group-meeting/types";

export const fetchLessonClassGroupMeeting = async (
  scheduleId: string,
  signal?: AbortSignal,
): Promise<GroupMeeting> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/group-meeting`;

  const { data } = await apiService.get<ClassroomGroupMeetingResource>(url, {
    signal,
  });

  return groupMeetingFromDto(data as unknown as GroupMeetingDto);
};

/**
 * Rejects (404) when no group meeting covering this lesson group is open.
 */
export const fetchLessonClassOpenGroupMeeting = async (
  scheduleId: string,
  signal?: AbortSignal,
): Promise<ClassroomLessonClassOpenGroupMeeting> => {
  const url = `/api/my-lessongroups/${encodeURIComponent(scheduleId)}/group-meeting/open`;

  const { data } = await apiService.get<LessonClassOpenGroupMeetingResource>(
    url,
    { signal },
  );

  return lessonClassOpenGroupMeetingFromDto(data);
};
